<template>
  <div class="rich-input" v-click-outside="closeDrawer">
    <rich
      v-show="type === 'common'"
      ref="rich"
      :value="value"
      @input="emitVal"
      :disabled="disabled"
      @fullscreenStateChanged="fullscreenStateChanged"
    ></rich>
    <dropdown
      v-if="type === 'dropdown'"
      trigger="click"
      placement="top-start"
      width="280"
      margin-top="0"
      popover-class="rich-text-popover"
      :disabled="disabled"
      @show="dropdownVisible = true"
      @hide="dropdownVisible = false"
    >
      <rich
        v-if="dropdownVisible"
        ref="rich"
        :value="value"
        :disabled="disabled"
        @input="emitVal"
        @fullscreenStateChanged="fullscreenStateChanged"
      ></rich>
      <template slot="reference">
        <div :class="['description', disabled ? 'disabled' : '']">{{ valForShow }}</div>
      </template>
    </dropdown>
  </div>
</template>

<script>
import Dropdown from "@/components/UIComponents/Dropdown"
import Rich from "@/components/Sheet/SheetForm/FormItem/Rich"

export default {
  name: "rich-input",
  components: { Rich, Dropdown },
  props: {
    value: String,
    type: {
      type: String,
      default: "common" // common dropdown
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dropdownVisible: false
    }
  },
  computed: {
    valForShow() {
      if (this.type === "common") return ""
      let tempNode = document.createElement("div")
      tempNode.innerHTML = this.value || ""
      return tempNode.innerText
    }
  },
  methods: {
    emitVal(val) {
      this.$emit("input", val)
    },
    fullscreenStateChanged(state) {
      this.$emit("fullscreen-state-changed", state)
    },
    forceUpdate() {
      this.$refs.rich?.forceUpdate()
    },
    closeDrawer() {
      this.$refs.rich?.closeDrawer()
    }
  }
}
</script>

<style lang="scss" scoped>
.rich-input {
  .description {
    display: flex;
    align-items: center;
    min-height: 32px;
    line-height: 24px;
    font-size: 14px;
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    box-sizing: border-box;
    color: #303133;
    padding: 0 15px;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    width: 100%;
    cursor: pointer;
    &.disabled {
      background-color: #f5f7fa;
    }
  }
}
</style>
